import React, { useState } from "react";
import { TspModal, TspFormField } from "../../../components/primitives";

const REASON_MAX = 1000;

// Cancelling needs a reason (kept in the journey's history). The dialog stays open
// while the request runs, so a refusal can be read and nothing typed is lost.
export default function JourneyCancelModal({ busy, error, onConfirm, onClose }) {
  const [reason, setReason] = useState("");
  const trimmed = reason.trim();

  return (
    <TspModal
      open
      title="Cancel this journey?"
      size="sm"
      onClose={busy ? undefined : onClose}
      footer={
        <>
          <button type="button" className="tsp-btn tsp-btn-outline" onClick={onClose} disabled={busy}>
            Keep Journey
          </button>
          <button type="button" className="tsp-btn tsp-btn-red" onClick={() => onConfirm(trimmed)} disabled={busy || !trimmed}>
            {busy ? "Cancelling…" : "Cancel Journey"}
          </button>
        </>
      }
    >
      <p className="tsp-confirm-message">A cancelled journey cannot be started again. Please say why it is being cancelled.</p>
      <TspFormField id="tsp-cancel-reason" label="Reason" required hint={`${reason.length}/${REASON_MAX} characters`}>
        <textarea id="tsp-cancel-reason" className="tsp-field-control tsp-textarea" rows={3} value={reason} maxLength={REASON_MAX} onChange={(event) => setReason(event.target.value)} disabled={busy} />
      </TspFormField>
      {error && (
        <p className="tsp-form-error" role="alert">
          {error}
        </p>
      )}
    </TspModal>
  );
}
